export default defineAppConfig({
  ui: {

    primary: "indigo",
    gray: "neutral",

    notifications: {
      position: "bottom-auto top-0",
    },

    tooltip: {
      background: "dark:bg-gray-900 bg-white",
      color: "text-gray-900 dark:text-white",
      rounded: "rounded-[3px]",
      ring: "ring-0",
      base: "border border-gray-200 dark:border-gray-700 overflow-visible whitespace-normal h-auto py-1 px-2 font-medium",
      arrow: {
        ring: "before:ring-0",
        background: "dark:before:bg-gray-900 before:bg-white",
      },
      popper: {
        strategy: "absolute"
      }
    },

    textarea: {
      rounded: "rounded-[3px]",
    },

    table: {
      divide: "divide-y-0",
      thead: "sticky top-0 left-0 w-full z-30 outline-none !bg-gray-50 dark:!bg-gray-800",
      tbody: "bg-white dark:bg-gray-900 divide-y-0",
      tr: {
        base: "hover:bg-gray-100 dark:hover:bg-gray-700 cursor-default",
        selected: "bg-white dark:bg-gray-900",
        active: "hover:bg-gray-100 dark:hover:bg-gray-800/50 cursor-default",
      },
      th: {
        padding: "px-3 pt-2 pb-2",
        font: "font-medium",
        size: "text-xs"
      },
      td: {
        padding: "px-3 py-1.5",
        size: "text-xs"
      },
      checkbox: {
        padding: "ps-[18px]"
      },
    },

    modal: {
      background: "!bg-inherit",
      shadow: "!shadow-none",
      rounded: "!rounded-none",
      padding: 'p-0'
    },

    tabs: {
      wrapper: "relative space-y-2",
      container: "relative w-full",
      base: "focus:outline-none",
      list: {
        base: "relative border dark:border-gray-700",
        background: "bg-gray-100 dark:bg-gray-800",
        rounded: "rounded-[4px]",
        shadow: "",
        padding: "py-1 px-1.5",
        height: "",
        width: "",
        marker: {
          wrapper: "absolute top-[4px] left-[4px] duration-200 ease-out focus:outline-none",
          base: "w-full h-full",
          background: "bg-white dark:bg-gray-900",
          rounded: "rounded-[2px]",
          shadow: "shadow-sm"
        },
        tab: {
          base: "relative inline-flex items-center justify-center flex-shrink-0 w-full ui-focus-visible:outline-0 ui-focus-visible:ring-2 ui-focus-visible:ring-primary-500 dark:ui-focus-visible:ring-primary-400 ui-not-focus-visible:outline-none focus:outline-none disabled:cursor-not-allowed disabled:opacity-75 transition-colors duration-200 ease-out",
          background: "",
          active: "text-gray-900 dark:text-white",
          inactive: "text-gray-500 dark:text-gray-400",
          height: "h-6",
          padding: "px-2",
          size: "text-xs",
          font: "font-medium",
          rounded: "rounded-md",
          shadow: "",
          icon: "w-4 h-4 flex-shrink-0 me-1"
        }
      }
    },

    notification: {
      wrapper: "w-full pointer-events-auto",
      container: "relative overflow-hidden",
      inner: "w-0 flex-1",
      title: "text-2xs font-semibold uppercase text-white/50 dark:text-black",
      description: "mt-1 text-xs font-medium text-white dark:text-black",
      actions: "flex items-center gap-2 mt-3 flex-shrink-0",
      background: "bg-gray-800 dark:bg-gray-200",
      rounded: "rounded-[4px]",
      padding: "pl-2 pr-4 py-1.5",
      gap: "gap-3",
      ring: "ring-1 ring-gray-200 dark:ring-gray-800",
      icon: {
        base: "flex-shrink-0 w-5 h-5",
        // color: "text-{color}-500 dark:text-{color}-400"
        color: "text-white dark:text-black"
      },
      progress: {
        base: "h-0",
        background: "bg-{color}-500 dark:bg-{color}-400"
      },
    },


    popover: {
      base: "overflow-visible",
      wrapper: "relative",
      background: "!bg-none",
      shadow: "!shadow-none",
      rounded: "!rounded-none",
      ring: "!ring-0",
    },


    toggle: {
      base: "relative inline-flex flex-shrink-0 border-2 border-transparent disabled:cursor-not-allowed disabled:opacity-50 focus:outline-none",
      rounded: "rounded-full",
      ring: "focus-visible:ring-2 focus-visible:ring-{color}-500 dark:focus-visible:ring-{color}-400 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-gray-900",
      active: "bg-{color}-500 dark:bg-{color}-400",
      inactive: "bg-gray-200 dark:bg-gray-700",
      size: {
        "2xs": "h-[0.767rem] w-5",
        xs: "h-3.5 w-6",
        sm: "h-4 w-7",
        md: "h-5 w-9",
        lg: "h-6 w-11",
        xl: "h-7 w-[3.25rem]",
        "2xl": "h-8 w-[3.75rem]"
      },
      container: {
        base: "pointer-events-none relative inline-block rounded-full bg-white dark:bg-gray-900 shadow transform ring-0 transition ease-in-out duration-200",
        active: {
          "2xs": "translate-x-2 rtl:-translate-x-2",
          xs: "translate-x-2.5 rtl:-translate-x-2.5",
          sm: "translate-x-3 rtl:-translate-x-3",
          md: "translate-x-4 rtl:-translate-x-4",
          lg: "translate-x-5 rtl:-translate-x-5",
          xl: "translate-x-6 rtl:-translate-x-6",
          "2xl": "translate-x-7 rtl:-translate-x-7"
        },
        inactive: "translate-x-0 rtl:-translate-x-0",
        size: {
          "2xs": "h-2 w-2",
          xs: "h-2.5 w-2.5",
          sm: "h-3 w-3",
          md: "h-4 w-4",
          lg: "h-5 w-5",
          xl: "h-6 w-6",
          "2xl": "h-7 w-7"
        }
      },
      icon: {
        base: "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity",
        active: "opacity-100 ease-in duration-200",
        inactive: "opacity-0 ease-out duration-100",
        size: {
          "2xs": "h-2 w-2",
          xs: "h-2 w-2",
          sm: "h-2 w-2",
          md: "h-3 w-3",
          lg: "h-4 w-4",
          xl: "h-5 w-5",
          "2xl": "h-6 w-6"
        },
        on: "text-{color}-500 dark:text-{color}-400",
        off: "text-gray-400 dark:text-gray-500",
        loading: "animate-spin text-{color}-500 dark:text-{color}-400"
      }
    },

    badge: {
      base: "font-medium",
      rounded: "!rounded-[3px]",
      color: {
        gray: {
          solid: "dark:bg-gray-900"
        },
      },
      variant: {
        outline: "ring-{color}-300 dark:ring-{color}-700",
      },
      default: {
        size: "xs",
        variant: "outline",
        color: "gray",
      }
    },

    contextMenu: {

      rounded: "rounded-[4px]",

    },

    verticalNavigation: {
      wrapper: "relative",
      base: "group relative flex items-center aria-[disabled='true']:opacity-50 gap-1.5 focus:outline-none focus-visible:outline-none dark:focus-visible:outline-none focus-visible:before:ring-inset focus-visible:before:ring-1 focus-visible:before:ring-primary-500 dark:focus-visible:before:ring-primary-400 before:absolute before:inset-px before:rounded-[4px] disabled:cursor-not-allowed disabled:opacity-75",
      ring: "focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400",
      padding: "px-2.5 py-1.5",
      width: "w-full",
      rounded: "rounded-[4px]",
      font: "font-medium",
      size: "text-sm",
      active: "text-gray-900 dark:text-white before:bg-gray-100 dark:before:bg-gray-700",
      inactive: "text-gray-500 dark:text-gray-400 disabled:bg-red-500 hover:text-gray-900 dark:hover:text-white aria-[disabled='true']:text-gray-500 hover:before:bg-gray-50 dark:hover:before:bg-gray-800/50",
      label: "truncate relative",
      icon: {
        base: "flex-shrink-0 w-5 h-5 mr-1 relative",
        active: "text-gray-700 dark:text-gray-200",
        inactive: "text-gray-400 dark:text-gray-500 group-hover:text-gray-700 dark:group-hover:text-gray-200"
      },
      divider: {
        wrapper: {
          base: "p-2"
        }
      }
    },

    select: {
      wrapper: "relative",
      base: "relative block w-full disabled:cursor-not-allowed disabled:opacity-75 focus:outline-none border-0",
      form: "form-select",
      rounded: "rounded-[4px]",
      placeholder: "text-gray-400 dark:text-gray-500",
      file: {
        base: "file:mr-1.5 file:font-medium file:text-gray-500 dark:file:text-gray-400 file:bg-transparent file:border-0 file:p-0 file:outline-none"
      },
      size: {
        "2xs": "text-xs",
        xs: "text-xs",
        sm: "text-sm",
        md: "text-sm",
        lg: "text-sm",
        xl: "text-base"
      },
      gap: {
        "2xs": "gap-x-1",
        xs: "gap-x-1.5",
        sm: "gap-x-1.5",
        md: "gap-x-2",
        lg: "gap-x-2.5",
        xl: "gap-x-2.5"
      },
      padding: {
        "2xs": "px-2 py-1",
        xs: "px-2.5 py-1.5",
        sm: "px-2.5 py-1.5",
        md: "px-3 py-2",
        lg: "px-3.5 py-2.5",
        xl: "px-3.5 py-2.5"
      },
      leading: {
        padding: {
          "2xs": "ps-7",
          xs: "ps-8",
          sm: "ps-9",
          md: "ps-10",
          lg: "ps-11",
          xl: "ps-12"
        }
      },
      trailing: {
        padding: {
          "2xs": "pe-7",
          xs: "pe-8",
          sm: "pe-9",
          md: "pe-10",
          lg: "pe-11",
          xl: "pe-12"
        }
      },
      color: {
        white: {
          outline: "shadow-sm bg-white dark:bg-gray-900 text-gray-900 dark:text-white ring-1 ring-inset ring-gray-300 dark:ring-gray-700 focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400"
        },
        gray: {
          outline: "shadow-sm bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white ring-1 ring-inset ring-gray-300 dark:ring-gray-700 focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400"
        }
      },
      variant: {
        outline: "shadow-sm bg-transparent text-gray-900 dark:text-white ring-1 ring-inset ring-{color}-500 dark:ring-{color}-400 focus:ring-2 focus:ring-{color}-500 dark:focus:ring-{color}-400",
        none: "bg-transparent focus:ring-0 focus:shadow-none"
      },
      icon: {
        base: "flex-shrink-0 text-gray-400 dark:text-gray-500",
        color: "text-{color}-500 dark:text-{color}-400",
        loading: "animate-spin",
        size: {
          "2xs": "h-4 w-4",
          xs: "h-4 w-4",
          sm: "h-5 w-5",
          md: "h-5 w-5",
          lg: "h-5 w-5",
          xl: "h-6 w-6"
        },
        leading: {
          wrapper: "absolute inset-y-0 start-0 flex items-center",
          pointer: "pointer-events-none",
          padding: {
            "2xs": "px-2",
            xs: "px-2",
            sm: "px-2.5",
            md: "px-3",
            lg: "px-3.5",
            xl: "px-3.5"
          }
        },
        trailing: {
          wrapper: "absolute inset-y-0 end-0 flex items-center",
          pointer: "pointer-events-none",
          padding: {
            "2xs": "px-2",
            xs: "px-2.5",
            sm: "px-2.5",
            md: "px-3",
            lg: "px-3.5",
            xl: "px-3.5"
          }
        }
      },
      default: {
        size: "sm",
        color: "white",
        variant: "outline",
        loadingIcon: "i-heroicons-arrow-path-20-solid",
        trailingIcon: "i-heroicons-chevron-down-20-solid"
      }
    },

    input: {
      base: "disabled:shadow-none disabled:drop-shadow-none",
      rounded: "rounded-[3px]",
      padding: {
        sm: "px-2.5 py-[5px]",
      },
      leading: {
        padding: {
          xs: "ps-8",
          sm: "ps-8",
        }
      },
      variant: {
        outline: "bg-white dark:bg-gray-800"
      },
      color: {
        gray: {
          outline: "dark:bg-gray-800"
        }
      }
    },

    inputMenu: {
      rounded: "rounded-[4px]",
      padding: "p-0",
      option: {
        rounded: "rounded-none",
        container: "divide-y divide-gray-200 dark:divide-gray-800"
      }
    },

    checkbox: {
      rounded: "rounded-[3px]",
    },

    button: {
      base: "active:!shadow-none disabled:shadow-none disabled:drop-shadow-none",
      rounded: "rounded-[0.25rem]",
      font: "font-medium",
      padding: {
        xs: "py-1 px-1.5",
        sm: "py-1.5"
      },
      icon: {
        size: {
          xs: "size-3.5",
          sm: "size-4",
        },
      },
    },

    selectMenu: {
      rounded: "rounded-[4px]",
      option: {
        padding: "py-1",
        selectedIcon: {
          base: "size-3.5"
        }
      },
      color: {
        gray: {
          outline: "dark:bg-gray-900"
        }
      },
    },

    buttonGroup: {
      shadow: "shadow-none",
      rounded: "rounded-md",
      orientation: {
        "rounded-md": { horizontal: { start: "rounded-s-[4px]", end: "rounded-e-[4px]" }, vertical: { start: "rounded-t-[4px]", end: "rounded-b-[4px]" } },
      }
    },

  },

});
